import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './pageContentSection.module.css'

interface IProps {
  children: React.ReactNode
  withShadow?: boolean
}

const PageContentSection = ({ children, withShadow }: IProps) => {
  const rootClasses = classnames(styles.root, {
    [styles.withShadow]: withShadow
  })
  return (
    <section className={rootClasses}>
      <div className={styles.content}>{children}</div>
    </section>
  )
}

export default PageContentSection
